function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class FetcherError extends Error {
    constructor(resp){
        super(resp.statusText);
        _define_property(this, "name", 'FetcherError');
        _define_property(this, "response", void 0);
        _define_property(this, "request", void 0);
        this.response = resp;
        this.request = resp.request;
    }
}
export class FetcherURLParseError extends Error {
    constructor(e = new TypeError('Failed to parse URL')){
        super(e.toString());
        _define_property(this, "name", 'FetcherURLParseError');
    }
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lcnJvci50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IEZldGNoZXJSZXF1ZXN0LCBGZXRjaGVyUmVzcG9uc2UgfSBmcm9tICdAL3R5cGVzJ1xuXG5leHBvcnQgY2xhc3MgRmV0Y2hlckVycm9yPFQgPSB1bmRlZmluZWQ+IGV4dGVuZHMgRXJyb3Ige1xuICBwdWJsaWMgbmFtZSA9ICdGZXRjaGVyRXJyb3InXG4gIHB1YmxpYyByZXNwb25zZTogRmV0Y2hlclJlc3BvbnNlPFQ+XG4gIHB1YmxpYyByZXF1ZXN0OiBGZXRjaGVyUmVxdWVzdFxuXG4gIGNvbnN0cnVjdG9yKHJlc3A6IEZldGNoZXJSZXNwb25zZTxUPikge1xuICAgIHN1cGVyKHJlc3Auc3RhdHVzVGV4dClcbiAgICB0aGlzLnJlc3BvbnNlID0gcmVzcFxuICAgIHRoaXMucmVxdWVzdCA9IHJlc3AucmVxdWVzdFxuICB9XG59XG5cbmV4cG9ydCBjbGFzcyBGZXRjaGVyVVJMUGFyc2VFcnJvciBleHRlbmRzIEVycm9yIHtcbiAgcHVibGljIG5hbWUgPSAnRmV0Y2hlclVSTFBhcnNlRXJyb3InXG5cbiAgY29uc3RydWN0b3IoZSA9IG5ldyBUeXBlRXJyb3IoJ0ZhaWxlZCB0byBwYXJzZSBVUkwnKSkge1xuICAgIHN1cGVyKGUudG9TdHJpbmcoKSlcbiAgfVxufVxuIl0sIm5hbWVzIjpbIkZldGNoZXJFcnJvciIsIkVycm9yIiwiY29uc3RydWN0b3IiLCJyZXNwIiwic3RhdHVzVGV4dCIsIm5hbWUiLCJyZXNwb25zZSIsInJlcXVlc3QiLCJGZXRjaGVyVVJMUGFyc2VFcnJvciIsImUiLCJUeXBlRXJyb3IiLCJ0b1N0cmluZyJdLCJyYW5nZU1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyIsIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBRUEsT0FBTyxNQUFNQSxxQkFBb0NDO0lBSy9DQyxZQUFZQyxJQUF3QixDQUFFO1FBQ3BDLEtBQUssQ0FBQ0EsS0FBS0MsVUFBVTtRQUx2Qix1QkFBT0MsUUFBTztRQUNkLHVCQUFPQyxZQUFQLEtBQUE7UUFDQSx1QkFBT0MsV0FBUCxLQUFBO1FBSUUsSUFBSSxDQUFDRCxRQUFRLEdBQUdIO1FBQ2hCLElBQUksQ0FBQ0ksT0FBTyxHQUFHSixLQUFLSSxPQUFPO0lBQzdCO0FBQ0Y7QUFFQSxPQUFPLE1BQU1DLDZCQUE2QlA7SUFHeENDLFlBQVlPLElBQUksSUFBSUMsVUFBVSxzQkFBc0IsQ0FBRTtRQUNwRCxLQUFLLENBQUNELEVBQUVFLFFBQVE7UUFIbEIsdUJBQU9OLFFBQU87SUFJZDtBQUNGIn0=